import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";

import { useIsSurfaceJobsEnabled } from "../../Placements/hooks/useIsSurfaceJobsEnabled";
import { getHasChildcareRoles } from "../util/childcareWorkerStorage";
import { useSelectedWorkType } from "./useSelectedWorkType";

export function useShouldShowJobsFirst(): boolean {
  const { data: worker } = useGetWorker();
  const isSurfaceJobsEnabled = useIsSurfaceJobsEnabled();
  const selectedWorkType = useSelectedWorkType();
  const hasChildcareRoles = getHasChildcareRoles(worker?.userId ?? "");

  const isChildcareWithBothWorkTypes =
    selectedWorkType.isFlexAndPermanentPlacementsOnboarding && hasChildcareRoles;

  return (
    isSurfaceJobsEnabled &&
    (selectedWorkType.isPermanentPlacementsOnboarding || isChildcareWithBothWorkTypes)
  );
}
